import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAllAccounts, deleteAccount } from "./AccountService";

export default function AccountList(){
  const [accounts,setAccounts] = useState([]);
  const nav = useNavigate();

  useEffect(()=>{ load(); },[]);

  const load = async ()=>{
    const data = await getAllAccounts();
    setAccounts(data);
  };

  const handleDelete = async (id)=>{
    if(!window.confirm("Delete account?")) return;
    await deleteAccount(id);
    load();
  };

  return (
    <div className="card">
      <button className="btn btn-primary" onClick={()=>nav("new")}>➕ Add Account</button>

      <div className="data-table-wrap">
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th>Type</th>
              <th>Balance</th>
              <th>Number</th>
              <th>Comment</th>
              <th>Active</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {accounts.map(a=>(
              <tr key={a.id}>
                <td>{a.accountName}</td>
                <td>{a.type}</td>
                <td>₹ {a.currentBalance}</td>
                <td>{a.accountNumber}</td>
                <td>{a.comment}</td>
                <td>{a.isActive ? "Yes":"No"}</td>
                <td>
                  <button className="btn" onClick={()=>nav(`edit/${a.id}`)}>✏️</button>
                  <button className="btn btn-danger" onClick={()=>handleDelete(a.id)}>🗑️</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
